// TODO: enum temporário, implementado apenas no layoutPDF converter numéro em string.
enum CategoriaPretendida {
    A =  0,
    B =  1,     
    AB = 2,
    ACC = 3,

}
export default  CategoriaPretendida;